<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    mounted() {
      const report = require('../../static/report.json');
      $('head title').text(`HIV QMR: ${this.$route.params.ha.toUpperCase()} ${report.period.slice(-7).replace(' ', '-')}`);
    },
    name: 'app',
    watch: {
      '$route' (to, from) {
        location.reload();
      }
    }
  }
</script>

<style>
  body {
    background-color: #fafafa;
  }
  #app {
    font-family: 'Lato', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    text-align: justify;
    text-justify: inter-word;
    font-size: 0.9em;
    padding-top: 10px;
    padding-bottom: 80px;
  }

  .label {
    z-index: 1 !important;
  }
  .highcharts-tooltip span {
    background-color: white;
    border:1 px solid green;
    opacity: 1;
    z-index: 9999 !important;
  }
  .tooltip {
    padding: 0px;
  }

  .center-aligned {
    text-align: center;
  }

  .right-aligned {
    text-align: right;
  }

  .bottom-aligned {
    vertical-align: bottom;
  }

  .inline-box {
    display: -webkit-inline-box;
  }

  .top-padded {
    padding-top: 40px;
  }

  .top-padded-2x {
    padding-top: 80px;
  }

  .bottom-padded {
    padding-bottom: 40px;
  }

  .bottom-padded-2x {
    padding-bottom: 80px;
  }

  .left-padded {
    padding-left: 80px;
  }

  a {
    color: #045fab;
    text-decoration: none;
  }
  a:hover, a:focus {
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// App.vue?5235a744